export default {
  "5b1e98f82f301e003908a070": "曲艺",
  "5b1b43899f5454003d833881": "课本",
  "5b1b46292f301e0038ae5297": "人文",
  "5b1b4609ac502e003432eaa8": "读书",
  "5b1a62729f5454003b06f815": "诗词",
  "5b1b45099f54540035fe9bd0": "佛学",
  "5b1b446ba22b9d0034ad012e": "生活",
  "5b1b42e0fe88c200367d108d": "音乐",
  "5b1dde5917d009003b14b61f": "戏曲",
  "5b1b448e17d009005ba0272d": "文化",
  "5b1b431d9f5454003d83356c": "儿童",
  "5b1a62df9f5454003b06faba": "语文",
  "5b1b46acd50eee0031e9af9d": "教育",
  "5b1b4424a22b9d0034acff35": "文学",
  "5b1b441f67f356003191f352": "国学",
  "5b1b429dfb4ffe0031345778": "诗歌",
}



// WEBPACK FOOTER //
// ./src/config/xct-tag-name-map.js